import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CTA } from "@/lib/ctas";

export default function NotFound() {
    return (
        <div className="min-h-[70vh] grid place-items-center px-5" data-testid="not-found-page">
            <div className="text-center max-w-lg">
                <div className="eyebrow" data-testid="not-found-eyebrow">— 404</div>
                <h1
                    className="font-display mt-4"
                    style={{ fontSize: "clamp(34px, 5vw, 52px)", fontWeight: 700, lineHeight: 1.08, color: "var(--text)" }}
                    data-testid="not-found-heading"
                >
                    That page has moved on.
                </h1>
                <p style={{ color: "var(--muted)", fontSize: 16, marginTop: 18, lineHeight: 1.6 }}>
                    The link's broken, but your next customer isn't. Head back home or tell us what you were after.
                </p>
                <div className="mt-8 flex flex-wrap gap-3 justify-center items-center">
                    <Link to="/" className="btn-primary" data-testid="not-found-home-btn">Back to home</Link>
                    <Link
                        to={CTA.CONTACT.href}
                        style={{ color: "var(--violet-bright)", fontSize: 14, fontWeight: 500, display: "inline-flex", alignItems: "center", gap: 4 }}
                        data-testid="not-found-contact-link"
                    >
                        {CTA.CONTACT.label} <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
            </div>
        </div>
    );
}
